import api from './authService';

export const adminEmailSettingsService = {
  // Get email settings
  get: async () => {
    const response = await api.get('/admin/email-settings');
    return response.data;
  },

  // Create or update email settings
  save: async (data) => {
    const response = await api.post('/admin/email-settings', data);
    return response.data;
  },

  // Test email configuration
  test: async (toEmail) => {
    const response = await api.post('/admin/email-settings/test', { to_email: toEmail });
    return response.data;
  },

  // Get verified domains from Mailtrap
  getDomains: async () => {
    const response = await api.get('/admin/email-settings/domains');
    return response.data;
  },
};

